module.exports = __webpack_public_path__ + "static/media/decyp-logo-text.724b63b0.svg";